import { render } from "./NavBar.vue?vue&type=template&id=4ef9e5cc&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=4ef9e5cc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef9e5cc"]])

export default __exports__